import { Text } from "@dropbox/dig-components/typography";
import { SuggestedQueryChips } from "@mirage/mosaics/Chat/components/chat/suggestions/SuggestedQueryChips";
import i18n from "@mirage/translations";
import { memo, useMemo } from "react";
import styles from "./ConversationSuggestedQueries.module.css";

import { PAPEvent } from "@mirage/analytics/events/base/event";
import { ActionSurfaceComponent } from "@mirage/analytics/events/enums/action_surface_component";
import type { ConversationSuggestedQuery } from "@mirage/service-conversation/types";
interface ConversationSuggestedQueriesProps {
  suggestedQueries: ConversationSuggestedQuery[];
  onSubmitText: (queryText: string) => void;
  logComposeEvent: (
    event: PAPEvent,
    overrides?: { actionSurfaceComponent?: ActionSurfaceComponent },
  ) => void;
  conversationId?: string;
  assistRequestId?: string;
}
/**
 * Displays a list of suggested queries as chips, with section title and padding to be used in
 * a conversation layout.
 */
export const ConversationSuggestedQueries = memo(
  ({
    suggestedQueries,
    onSubmitText,
    logComposeEvent,
    conversationId,
    assistRequestId,
  }: ConversationSuggestedQueriesProps) => {
    const queryTexts = useMemo(
      () => suggestedQueries.map((query) => query.text),
      [suggestedQueries],
    );
    return (
      <div className={styles.conversationSuggestedQueries}>
        <Text
          size="medium"
          tagName="div"
          className={styles.title}
          color="subtle"
        >
          {i18n.t("conversation_suggested_queries_title")}
        </Text>
        <SuggestedQueryChips
          suggestedQueries={queryTexts}
          onSubmit={onSubmitText}
          withPadding
          logComposeEvent={logComposeEvent}
          conversationId={conversationId}
          assistRequestId={assistRequestId}
        />
      </div>
    );
  },
);
ConversationSuggestedQueries.displayName = "ConversationSuggestedQueries";
